import angular from 'angular';

class GroupsService {
  constructor($http, localStorageService, Endpoints) {
    'ngInject';

    Object.assign(this, {
      $http,
      localStorageService,
      Endpoints
    });
  }

  getCategories() {
    return this.$http.get(this.Endpoints.groups.categories);
  }

  getProductGroupsAll() {
    return this.$http.get(this.Endpoints.groups.adminProductGroups);
  }

  createProductGroup(data) {
    return this.$http.post(this.Endpoints.groups.adminProductGroups, data);
  }

  getProductGroup(code) {
    return this.$http.get(this.Endpoints.groups.adminProductGroupOne.replace(":code", code));
  }

  updateProductGroup(code, data) {
    return this.$http.put(this.Endpoints.groups.adminProductGroupOne.replace(":code", code), data);
  }



  getProductGroupsByServiceCode(code) {
    return this.$http.get(this.Endpoints.groups.productGroupsByServiceCode.replace(":code", code));
  }

  getProductsByServiceCode(code) {
    return this.$http.get(this.Endpoints.groups.productsByServiceCode.replace(":code", code));
  }

}

GroupsService.$inject = ["$http", "localStorageService", "Endpoints"];
angular.module('pims').service('GroupsService', GroupsService);